export default __webpack_public_path__ + "static/media/pre-school.7b892d7f.jpg";